import { useMemo } from 'react';
import { Notifier } from '@airbrake/browser';

export const useAirbrake = () => useMemo(() => new Notifier({
  projectId: +(process.env.REACT_APP_AIRBRAKE_ID || '1'),
  projectKey: process.env.REACT_APP_AIRBRAKE_KEY || '1',
  environment: process.env.NODE_ENV,
}), []);
